import type { Item } from "../types.ts";

/**
 * Attribution — title, year, uploader, license/rights, and the "via
 * archive.org" link to the canonical details page.
 *
 * Constitutional (Principle III): this component is non-negotiable on
 * every playing item. The IA community's trust in Night Light depends on
 * it.
 */
export function Attribution({ item }: { item: Item }) {
  const sub = [item.year, item.uploader].filter(Boolean).join(" · ");

  return (
    <div className="attribution">
      <h2 className="title">{item.title}</h2>
      {sub && <div className="sub">{sub}</div>}
      {item.license && (
        <div className="sub">
          License:{" "}
          {item.license.kind === "url" ? (
            <a href={item.license.value} target="_blank" rel="noreferrer">
              {item.license.value}
            </a>
          ) : (
            <span>{item.license.value}</span>
          )}
        </div>
      )}
      <div className="via">
        <a href={item.detailsUrl} target="_blank" rel="noreferrer">
          via archive.org →
        </a>
      </div>
    </div>
  );
}
